module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      error: _vm.$v.scheduleTask.name.$error
    }
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleTask.name),
      expression: "scheduleTask.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.scheduleTask.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scheduleTask, "name", $event.target.value)
      }, _vm.$v.scheduleTask.name.$touch]
    }
  }), _vm._v(" "), (_vm.$v.scheduleTask.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.scheduleTask.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.scheduleTask.name.minLength) ? _c('span', [_vm._v("Name must have at least 4 characters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.scheduleTask.name.maxLength) ? _c('span', [_vm._v("Name should have 35 characters or less.")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('h5', [_vm._v("Task type")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.editMode,
      "options": _vm.typeOptions
    },
    on: {
      "input": _vm.typeChanged
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('h5', [_vm._v("Details")]), _vm._v(" "), _c('form-part-invoice', {
    attrs: {
      "scheduleTask": _vm.scheduleTask
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('h5', [_vm._v("Start Date and Repetition")]), _vm._v(" "), _c('cron-configure', {
    attrs: {
      "cron": _vm.scheduleTask.cron,
      "startDate": _vm.scheduleTask.periodStart,
      "disabledSTartDate": _vm.editMode
    },
    on: {
      "update:cron": function($event) {
        return _vm.$set(_vm.scheduleTask, "cron", $event)
      },
      "update:startDate": function($event) {
        return _vm.$set(_vm.scheduleTask, "periodStart", $event)
      },
      "update:start-date": function($event) {
        return _vm.$set(_vm.scheduleTask, "periodStart", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('h5', [_vm._v("Task completed notification")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleTask.emailListToSendResume),
      expression: "scheduleTask.emailListToSendResume"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.scheduleTask.emailListToSendResume)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scheduleTask, "emailListToSendResume", $event.target.value)
      }
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cfcdc0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduleTasks/components/scheduleTaskForm.vue
// module id = 1927
// module chunks = 0